import Form from "../../formability/form_builder/models/form";
import License from "../../formability/licenseBuilder/models/license";
import BuilderModel from "~/models/tracked/builderModel";
import Guid from "~/helpers/guid";

export default class CustomGeneratedIdSettings extends BuilderModel {

  is_enabled: boolean;
  prefix: string;
  prefix_formula: string;
  first_number: number;
  is_padding_number: boolean;
  num_places_to_pad_number: number;

  constructor(rootModel: Form | License) {
    super();
    this.rootModel = rootModel;
    this.parent = rootModel;
    this.defineProperty('client_id', Guid.create());
  }

}
